export const getReasons = ({ reportOptionReducer: { reasons = [] } = {} }) =>
  reasons;
export const getRepotOptionFilter = ({
  reportOptionReducer: { filter = {} } = {},
}) => filter;
export const getReportOptionCount = ({
  reportOptionReducer: { count = 0 } = {},
}) => count;
